module.exports = __webpack_public_path__ + "img/06.f52956ad.jpg";